<div
  class="carousel"
  attr.data-containerid="{{ container.id }}"
  [style.background-image]="
    sponsor && sponsor?.background && sponsor.tags.includes('background_image') ? 'url(' + sponsor?.background + ')' : 'none'
  "
  [style.background-color]="sponsor && sponsor?.background && sponsor.tags.includes('background_color') ? sponsor?.background : 'none'"
  [ngClass]="[
    sponsor ? 'sponsored-' + sponsor?.template : '',
    'cap' + container.aspectRatio,
    container.sourceType ? 'st' + container.sourceType : ''
  ]"
>
  <img
    *ngIf="sponsor && sponsor.template === 'logo' && sponsor?.logo"
    class="sponsor-image-title"
    [src]="container.sponsor.logo"
    alt=""
  />
  <div class="carousel-rail">
    <h1 class="carousel-title" *ngIf="showName">
      <span class="carousel-title-label"> {{  container.name }}</span>
      <h2 [id]="'carouselTitle'+container.id" style="display: none;" *ngIf="!hasFocusedFirstCard" >{{  container.name }}</h2>
      <ng-container *ngIf="sponsor && sponsor.template === 'label'">
        <span class="sponsored-title-label" *ngIf="sponsor?.label">{{ sponsor.label }}</span>
        <img class="sponsored-title-image" *ngIf="sponsor?.logo" [src]="sponsor.logo" alt="" />
      </ng-container>
    </h1>
    <div class="hide-scrollbar" #carouselContainer (focusout)="focusOnContainer($event)">
      <ng-container *ngIf="carouselType === carouselTypes.SMALL_CIRCLE">
        <div
          (keydown)="keyDownImage($event, container.resources.length, 8)"
          data-left="tv-menu"
          class="scroll rounded focusable-container horizontal-focusable-container"
        >
          <div class="rightArrow" *ngIf="showRightArrow" (click)="keyDownImage({ keyCode: 39 }, container.resources.length, 8)"></div>
          <div class="leftArrow" *ngIf="showLeftArrow" (click)="keyDownImage({ keyCode: 37 }, container.resources.length, 8)"></div>

          <div
            class="image-parent containerParent focusable-element"
            tabindex="0"
            [ngStyle]="move"
            *ngFor="let item of container?.resources; let i = index"
            (mouseover)="onEnterCard($event, i)"
            (focus)="onFocus($event, item, i)"
            (focusout)="onFocusOut($event)"
            (click)="watchMovie(item)"
            [attr.aria-labelledby]="i === 0 ? 'carouselTitle'+container.id+' cardTitle' + item.id : 'cardTitle' + item.id"
          >
          <span id="cardTitle{{item.id}}" style="display: none;">{{'.' | ttsConcat: item.title : item.shortDescription}}</span>
            <img
              height="auto"
              width="{{ getImageWidth(item) }}"
              class="image-parent__1x1--smaller"
              loading="lazy"
              src="{{ item.image }}"
              alt=""
              onerror="this.classList.add('no-image');"
            />
          </div>
          <!-- View More Card -->
          <div
            lass="image-parent containerParent focusable-element view_more"
            tabindex="0"
            (mouseover)="onEnterCard($event, container.resources.length)"
            [ngStyle]="move"
            *ngIf="container?.viewAll"
            (click)="watchMovie(undefined)"
            [attr.aria-label]="'More' | translate"
          ></div>
        </div>
      </ng-container>

      <ng-container *ngIf="carouselType === carouselTypes.SQUARE_SMALL">
        <div
          (keydown)="keyDownImage($event, container.resources.length, 10)"
          data-left="tv-menu"
          class="scroll genres focusable-container horizontal-focusable-container"
        >
          <div class="rightArrow" *ngIf="showRightArrow" (click)="keyDownImage({ keyCode: 39 }, container.resources.length, 10)"></div>
          <div class="leftArrow" *ngIf="showLeftArrow" (click)="keyDownImage({ keyCode: 37 }, container.resources.length, 10)"></div>

          <div
            tabindex="0"
            [ngStyle]="move"
            class="containerParent focusable-element"
            *ngFor="let item of container.resources; let i = index"
            (click)="watchMovie(item)"
            (mouseover)="onEnterCard($event, i)"
            (focus)="onFocus($event, item, i)"
            (focusout)="onFocusOut($event)"
            [attr.aria-labelledby]="i === 0 ? 'carouselTitle'+container.id+' cardTitle' + item.id : 'cardTitle' + item.id"
          >
          <span id="cardTitle{{item.id}}" style="display: none;">{{'.' | ttsConcat: item.title : item.shortDescription}}</span>
            <div class="image-parent">
              <div class="gradientParent"></div>
              <img
                height="auto"
                class="smallSquareImage skeleton"
                width="{{ getImageWidth(item) }}"
                loading="lazy"
                src="{{ item.image }}"
                alt=""
                onerror="this.classList.add('no-image'); this.classList.remove('skeleton');"
              />
            </div>
          </div>
          <!-- View More Card NO VIEW MORE IN THIS CARD-->
        </div>
      </ng-container>

      <ng-container *ngIf="carouselType === carouselTypes.ON_GOING">
        <div
          (keydown)="keyDownImage($event, container.resources.length, container.aspectRatio)"
          data-left="tv-menu"
          class="scroll size-large focusable-container horizontal-focusable-container ongoing-carousel"
          [attr.data-blocked]="isPopup"
          [ngClass]="[container.aspectRatio | cardsAspectRatioClass, className]"
        >
          <div
            class="rightArrow"
            *ngIf="showRightArrow"
            (click)="keyDownImage({ keyCode: 39 }, container.resources.length, container.aspectRatio)"
          ></div>
          <div
            class="leftArrow"
            *ngIf="showLeftArrow"
            (click)="keyDownImage({ keyCode: 37 }, container.resources.length, container.aspectRatio)"
          ></div>

          <div
            *ngFor="let item of container?.resources; let i = index"
            [ngStyle]="move"
            class="containerParent focusable-element"
            tabindex="0"
            (mouseover)="onEnterCard($event, i)"
            (focus)="onFocus($event, item, i)"
            (focusout)="onFocusOut($event)"
            (click)="watchMovie(item)"
            [attr.aria-labelledby]="i === 0 ? 'carouselTitle'+container.id+' cardTitle' + item.id : 'cardTitle' + item.id"
          >
          <span id="cardTitle{{item.id}}" style="display: none;">{{'.' | ttsConcat: item.title : item.shortDescription}}</span>
          <div class="image-parent">
              <app-tag [isBlocked]="item.isPremium" position="top-right"></app-tag>
              <app-tag *ngIf="showTag && item.tag" [text]="item.tag"></app-tag>
              <app-tag *ngIf="item.isLive" [isLive]="true" position="top-left" color="dark"></app-tag>
                <img
                  height="auto"
                  class="skeleton"
                  width="{{ getImageWidth(item) }}"
                  [ngClass]="container.aspectRatio | imagesAspectRatioClass"
                  loading="lazy"
                  [src]="item.image+'?w=600&h=337'"
                  alt=""
                  onerror="this.src=''"
                  onerror="this.classList.add('no-image'); this.classList.remove('skeleton');"
                />
              <div *ngIf="sponsor && sponsor.template === 'logo' && sponsor?.logo && item?.isLive" class="live-tag"></div>
              <div *ngIf="!item.isPremium" class="play-button"></div>
            </div>
            <div class="ongoing-carousel__data">
              <img class="ongoing-carousel__data__logo" src="{{ item.channel.image }}" alt="channel-image" />
              <div class="ongoing-carousel__data__text">
                <span class="ongoing-carousel__data__text-title">{{item.title}}</span>
                <span class="ongoing-carousel__data__text-hour">{{item.shortDescription}}</span>
              </div>
            </div>
          </div>
          <!-- View More Card -->
          <div
            *ngIf="container?.viewAll"
            [ngStyle]="move"
            class="containerParent focusable-element"
            tabindex="0"
            (mouseover)="onEnterCard($event, container.resources.length)"
            (click)="watchMovie(undefined)"
            [attr.aria-label]="'More' | translate"
          >
            <div class="image-parent view_more">
              <div class="view_more__text" [ngClass]="container.aspectRatio | imagesAspectRatioClass">
                {{ 'More >' | translate }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="carouselType === carouselTypes.SQUARE_LARGE">
        <div
          (keydown)="keyDownImage($event, container.resources.length, container.aspectRatio)"
          data-left="tv-menu"
          class="scroll size-large focusable-container horizontal-focusable-container default"
          [attr.data-blocked]="isPopup"
          [ngClass]="[container.aspectRatio | cardsAspectRatioClass, className]"
        >
          <div
            class="rightArrow"
            *ngIf="showRightArrow"
            (click)="keyDownImage({ keyCode: 39 }, container.resources.length, container.aspectRatio)"
          ></div>
          <div
            class="leftArrow"
            *ngIf="showLeftArrow"
            (click)="keyDownImage({ keyCode: 37 }, container.resources.length, container.aspectRatio)"
          ></div>

          <div
            *ngFor="let item of container?.resources; let i = index"
            [ngStyle]="move"
            class="containerParent focusable-element"
            tabindex="0"
            (mouseover)="onEnterCard($event, i)"
            (focus)="onFocus($event, item, i)"
            (focusout)="onFocusOut($event)"
            (click)="watchMovie(item)"
            [attr.aria-labelledby]="i === 0 ? 'carouselTitle'+container.id+' cardTitle' + item.id : 'cardTitle' + item.id"
          >
          <span id="cardTitle{{item.id}}" style="display: none;">{{'.' | ttsConcat: item.title : item.shortDescription}}</span>
          <div class="image-parent">
              <app-tag [isBlocked]="item.isPremium" position="top-right"></app-tag>
              <app-tag *ngIf="showTag && item.tag" [text]="item.tag"></app-tag>
              <app-tag *ngIf="item.isLive" [isLive]="true" position="top-left" color="dark"></app-tag>
                <img
                  height="auto"
                  class="skeleton"
                  width="{{ getImageWidth(item) }}"
                  [ngClass]="container.aspectRatio | imagesAspectRatioClass"
                  loading="lazy"
                  src="{{ item.image }}"
                  alt=""
                  onerror="this.src=''"
                  onerror="this.classList.add('no-image'); this.classList.remove('skeleton');"
                />
              <div *ngIf="sponsor && sponsor.template === 'logo' && sponsor?.logo && item?.isLive" class="live-tag"></div>
              <!-- <div *ngIf="showPlayIcon" class="gradient"></div> -->
              <div *ngIf="showPlayIcon" class="play-button"></div>
              <div *ngIf="showProgress" class="fulloffset">
                <div
                  class="actualoffset"
                  [ngStyle]="{ width: item.offset ? item.offset + '%' : -1, minWidth: '5%', maxWidth: '90%' }"
                ></div>
              </div>
            </div>
          </div>
          <!-- View More Card -->
          <div
            *ngIf="container?.viewAll"
            [ngStyle]="move"
            class="containerParent focusable-element"
            tabindex="0"
            (mouseover)="onEnterCard($event, container.resources.length)"
            (click)="watchMovie(undefined)"
            [attr.aria-label]="'More' | translate"
          >
            <div class="image-parent view_more">
              <div class="view_more__text" [ngClass]="container.aspectRatio | imagesAspectRatioClass">
                {{ 'More >' | translate }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="carouselType === carouselTypes.SQUARE_REGULAR">
        <div
          (keydown)="keyDownImage($event, container.resources.length, container.aspectRatio)"
          data-left="tv-menu"
          class="scroll focusable-container horizontal-focusable-container default"
          [attr.data-blocked]="isPopup"
          [ngClass]="[container.aspectRatio | cardsAspectRatioClass, className]"
        >
          <div
            class="rightArrow"
            *ngIf="showRightArrow"
            (click)="keyDownImage({ keyCode: 39 }, container.resources.length, container.aspectRatio)"
          ></div>
          <div
            class="leftArrow"
            *ngIf="showLeftArrow"
            (click)="keyDownImage({ keyCode: 37 }, container.resources.length, container.aspectRatio)"
          ></div>

          <div
            *ngFor="let item of container?.resources; let i = index"
            [ngStyle]="move"
            class="containerParent focusable-element"
            tabindex="0"
            (mouseover)="onEnterCard($event, i)"
            (focus)="onFocus($event, item, i)"
            (focusout)="onFocusOut($event)"
            (click)="watchMovie(item)"
            [attr.aria-labelledby]="i === 0 ? 'carouselTitle'+container.id+' cardTitle' + item.id : 'cardTitle' + item.id"
          >
          <span id="cardTitle{{item.id}}" style="display: none;">{{'.' | ttsConcat: item.title : item.shortDescription}}</span>
          <div class="image-parent">
            <app-tag [isBlocked]="item.isPremium" position="top-right"></app-tag>
              <app-tag *ngIf="showTag && item.tag" [text]="item.tag"></app-tag>
              <app-tag *ngIf="item.isLive" [isLive]="true" position="top-left" color="dark"></app-tag>
                <img
                  height="auto"
                  class="skeleton"
                  width="{{ getImageWidth(item) }}"
                  [ngClass]="container.aspectRatio | imagesAspectRatioClass"
                  loading="lazy"
                  src="{{ item.image }}"
                  alt=""
                  onerror="this.src=''"
                  onerror="this.classList.add('no-image'); this.classList.remove('skeleton');"
                />
              <div *ngIf="sponsor && sponsor.template === 'logo' && sponsor?.logo && item?.isLive" class="live-tag"></div>
              <!-- <div *ngIf="showPlayIcon" class="gradient"></div> -->
              <div *ngIf="showPlayIcon" class="play-button"></div>
              <div *ngIf="showProgress" class="fulloffset">
                <div
                  class="actualoffset"
                  [ngStyle]="{ width: item.offset ? item.offset + '%' : -1, minWidth: '5%', maxWidth: '90%' }"
                ></div>
              </div>
            </div>
          </div>
          <!-- View More Card -->
          <div
            *ngIf="container?.viewAll"
            [ngStyle]="move"
            class="containerParent focusable-element"
            tabindex="0"
            (mouseover)="onEnterCard($event, container.resources.length)"
            (click)="watchMovie(undefined)"
            [attr.aria-label]="'More' | translate"
          >
            <div class="image-parent view_more">
              <div class="view_more__text" [ngClass]="container.aspectRatio | imagesAspectRatioClass">
                {{ 'More >' | translate }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="carouselType === carouselTypes.SQUARE_REGULAR_WITH_DESCRIPTION">
        <div
          (keydown)="keyDownImage($event, container.resources.length, 20)"
          data-left="tv-menu"
          class="scroll focusable-container horizontal-focusable-container"
          [ngClass]="[className]"
        >
          <div
            *ngFor="let item of container?.resources; let i = index"
            class="containerParent focusable-element squareRegularWithDescription"
            tabindex="0"
            [ngStyle]="move"
            (mouseover)="onEnterCard($event, i)"
            (focus)="onFocus($event, item, i)"
            (focusout)="onFocusOut($event)"
            (click)="watchMovie(item)"
            [attr.index]="i"
            [attr.aria-labelledby]="i === 0 ? 'carouselTitle'+container.id+' cardTitle' + item.id : 'cardTitle' + item.id"
          >
          <span id="cardTitle{{item.id}}" style="display: none;">{{'.' | ttsConcat: item.title : item.shortDescription}}</span>
            <div class="card">
              <div class="card__image">
                <div class="image-parent">
                  <img
                    [ngClass]="container.aspectRatio | imagesAspectRatioClass"
                    alt=""
                    src="{{ item.image }}"
                    onerror="this.classList.add('no-image');"
                  />
                  <app-tag [isBlocked]="item.isPremium" position="top-right"></app-tag>
                  <app-tag *ngIf="showTag && item.tag" [text]="item.tag"></app-tag>
                  <app-tag *ngIf="item.isLive" [isLive]="true" position="top-left" color="dark"></app-tag>
                  <div *ngIf="showPlayIcon" class="gradient"></div>
                  <div *ngIf="showPlayIcon" class="playButton-position"></div>
                </div>
                <div class="card__title carousel-card-title">{{ item.title }}</div>
                <div class="card__details carousel-card-title" *ngIf="item">
                  {{ item.name.split(':')[0] }} • {{ item.timeLeft | date : 'd MMM, yyyy' }} • {{ item.runningTime }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
